/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PositionWorksite {
  Onsite = "Onsite",
  Remote = "Remote",
  OnsiteRemote = "Onsite/Remote",
}

export const PositionWorksiteDisplay: Record<PositionWorksite, string> = {
  [PositionWorksite.Onsite]: "Onsite",
  [PositionWorksite.Remote]: "Remote",
  [PositionWorksite.OnsiteRemote]: "Onsite/Remote",
};
